module.exports = __webpack_public_path__ + "media/images/area/popular/nagoya-f02903f9e9da4f7b6ff9bb4d2c1aacdd.jpg";